import LoginComponent from "./LoginComponent.js";
import { useLocation } from 'react-router-dom';
import { useState } from 'react';
import maskGroupImage from '../../images/doctor_image.png';
import logoImage from '../../images/group_4-2x.png';
import AboutUsModal from './AboutUsModal.js';
import ContactUsModal from './ContactUsModal.js';

export default function LandingPage() {
    const location = useLocation();
    const [isAboutUsOpen, setIsAboutUsOpen] = useState(false);
    const [isContactUsOpen, setIsContactUsOpen] = useState(false);
    return (
        <div className="flex flex-col lg:flex-row min-h-screen relative">
            {/* Navigation tabs in top-right corner */}
            <div className="absolute top-4 right-4 z-20 flex flex-col sm:flex-row gap-2">
                <button
                    onClick={() => setIsAboutUsOpen(true)}
                    className="px-4 py-2 bg-teal-700 text-white font-medium rounded-md hover:bg-teal-800 transition-colors focus:outline-none focus:ring-2 focus:ring-teal-500 focus:ring-offset-2 text-sm"
                >
                    About Us
                </button>
                <button
                    onClick={() => setIsContactUsOpen(true)}
                    className="px-4 py-2 bg-teal-700 text-white font-medium rounded-md hover:bg-teal-800 transition-colors focus:outline-none focus:ring-2 focus:ring-teal-500 focus:ring-offset-2 text-sm"
                >
                    Contact Us
                </button>
            </div>
            <div className="hidden lg:flex lg:w-1/2 items-center justify-center">
                {/* <div className="relative w-[563px] h-[416px]"> */}

                    {/* <div className="absolute -top-20 -left-20 w-64 h-64 pointer-events-none">
                        <VectorIcon className="w-full h-full" />
                    </div>

                    <div className="absolute -bottom-14 -right-10 w-48 h-48 pointer-events-none">
                        <VectorIcon2 className="w-full h-full" />
                    </div>

                    <div className="absolute -bottom-10 -right-4 w-20 h-20 pointer-events-none">
                        <VectorIcon3 className="w-full h-full" />
                    </div> */}

                    <div
                    className="w-full h-full shadow-lg rounded-lg bg-cover bg-center relative z-10"
                    style={{ backgroundImage: `url(${maskGroupImage})` }}
                    />
                {/* </div> */}
            </div>

            <div className="w-full lg:w-1/2 bg-gray-100 min-h-screen flex flex-col items-center justify-center px-4 py-8">
                <div className="mb-8">
                    <div className="h-[104px] w-[164px] mx-auto bg-cover bg-center" style={{ backgroundImage: `url(${logoImage})` }}></div>
                </div>
                <div className="text-center mb-8">
                    <div className="text-2xl md:text-3xl font-bold text-gray-900 max-w-md mx-auto leading-tight">Instant Appointments Service</div>
                    <div className="text-base md:text-lg text-gray-500 mt-2">We Care. Expanding Our Network of Trusted Doctors</div>
                    <div className="mt-6 flex flex-col sm:flex-row items-center justify-center gap-4">
                        <div className="flex items-center gap-2 px-4 py-2 bg-teal-50 rounded-lg border border-teal-200">
                            <div className="text-2xl">📱</div>
                            <div className="text-left">
                                <div className="text-sm font-semibold text-teal-800">Available on</div>
                                <div className="text-xs text-teal-600">Android & iPhone</div>
                            </div>
                        </div>
                        <div className="flex items-center gap-2 px-4 py-2 bg-teal-50 rounded-lg border border-teal-200">
                            <div className="text-2xl">🏥</div>
                            <div className="text-left">
                                <div className="text-sm font-semibold text-teal-800">Insta Appointments</div>
                                <div className="text-xs text-teal-600">Book appointments on the go</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="w-full max-w-md mb-8">
                    {location && location.state &&
                        <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded">
                            <div className="font-bold">Success!</div>
                            <div className="text-sm">{location.state.message}</div>
                            <div className="text-sm">Please login to continue.</div>
                        </div>
                    }
                </div>
                <div className="w-full max-w-md">
                    <LoginComponent />
                </div>
            </div>
            
            {/* Modals */}
            <AboutUsModal 
                isOpen={isAboutUsOpen} 
                onClose={() => setIsAboutUsOpen(false)} 
            />
            <ContactUsModal 
                isOpen={isContactUsOpen} 
                onClose={() => setIsContactUsOpen(false)} 
            />
        </div>
    );
}